module.exports = __webpack_public_path__ + "media/2-3.a9d7bf43.wav";